var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-h1 mt-8",class:!_vm.subtext ? 'mb-8' : ''},[_vm._v(_vm._s(_vm.type)+" Management")]),(_vm.subtext)?_c('p',{staticClass:"mb-8 text-body-1 font-italic"},[_vm._v(_vm._s(_vm.subtext))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }